{
  "title": "Account",
  "registerTitle": "Registration",
  "subtitle": "Sign in with email, Google, phone or Telegram - every method opens the same account and wallet.",
  "email": "Email",
  "password": "Password",
  "showPassword": "Show",
  "hidePassword": "Hide",
  "acceptTerms": "I accept the terms of use",
  "registerCta": "Create account",
  "haveAccount": "Already have an account?",
  "needAccount": "Need an account?",
  "telegramHint": "Telegram Mini App auto-login is enabled (initData verified on the server).",
  "unavailable": "Authentication is not active yet",
  "telegramSoon": "Telegram login coming soon",
  "webSoon": "Web login coming soon",
  "googleDisabled": "Google login disabled until OAuth is configured",
  "googleReady": "Continue with Google",
  "smsDisabled": "SMS login disabled until an SMS provider is configured",
  "smsReady": "Continue with phone",
  "orEmail": "Email",
  "registerShort": "Sign up",
  "loginTitle": "Sign in",
  "tabEmail": "Email",
  "tabPhone": "Phone",
  "emailPlaceholder": "Email",
  "phoneUnavailableTitle": "Phone sign-in is not active yet",
  "phoneUnavailableBody": "SMS delivery is not connected. Continue with email and password.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Enter a 9-digit Azerbaijan mobile number (e.g. 50 123 45 67).",
  "casinoBonusInactive": "No campaign is active yet",
  "socialMethods": "Social sign-in",
  "orContinue": "or",
  "continueWithTelegram": "Continue with Telegram",
  "casinoBonus": "Casino bonus",
  "noRegistrationBonus": "No registration bonus is available to choose right now.",
  "promoToggle": "Add a promo code",
  "promoPlaceholder": "Promo code",
  "promoHint": "The code is not applied during registration. You can enter it later on the Bonuses page.",
  "acceptTermsPrefix": "I have read and accept the ",
  "acceptTermsLink": "terms of use",
  "acceptTermsSuffix": ".",
  "acceptTermsRequired": "You must accept the terms to register.",
  "termsMissingNote": "A draft of the rules is on /qaydalar. Production publish needs separate approval. Tick the box to register.",
  "registerSubmit": "Create account",
  "loginSubmit": "Sign in",
  "socialSoon": "Google and Telegram web sign-in are not active yet.",
  "haveAccountPrompt": "Already have an account?",
  "haveAccountAction": "Sign in",
  "needAccountPrompt": "Need an account?",
  "needAccountAction": "Register",
  "resetPassword": "Reset password",
  "closeDialog": "Close",
  "forgotLink": "Forgot password?",
  "forgotTitle": "Reset password",
  "forgotIntro": "Enter the email of your account. If it is registered, we will send a reset link.",
  "forgotCta": "Send reset link",
  "forgotSent": "If an account with this email exists, a reset link is on its way. Check your inbox and spam folder.",
  "sendAgain": "Send again",
  "emailDeliveryOff": "Email delivery is not configured on this server yet, so no message will arrive.",
  "backToLogin": "Back to sign in",
  "resetTitle": "Choose a new password",
  "newPassword": "New password",
  "confirmPassword": "Repeat password",
  "passwordsDontMatch": "Passwords do not match",
  "passwordRules": "At least 8 characters, mixing letters with digits or symbols.",
  "resetCta": "Save new password",
  "resetDone": "Password changed. All sessions were signed out - sign in with the new password.",
  "linkInvalid": "This link is invalid, expired or has already been used.",
  "requestNewLink": "Request a new link",
  "checking": "Checking...",
  "verifyTitle": "Confirm email",
  "verifyIntro": "Press the button to confirm your email address.",
  "verifyCta": "Confirm email",
  "verifyDone": "Email confirmed. Thank you!",
  "verifyResendHint": "You can request a new confirmation email on the Security page.",
  "securityTitle": "Account security",
  "emailVerified": "Verified",
  "emailNotVerified": "Not verified",
  "resendVerification": "Send confirmation email again",
  "verificationSent": "Confirmation email sent.",
  "verificationSentAfterRegister": "Account created. We sent a confirmation link to your email.",
  "phoneTitle": "Sign in with phone",
  "phoneLinkTitle": "Add phone number",
  "phoneLabel": "Phone number",
  "phoneHint": "Azerbaijan numbers can be typed as 050 123 45 67. For other countries start with +.",
  "sendCode": "Send code",
  "codeLabel": "Code from SMS",
  "codeSentTo": "We sent a 6-digit code to {{phone}}.",
  "verifyCode": "Confirm",
  "resendCode": "Send code again",
  "resendIn": "Send again in {{seconds}} s",
  "changeNumber": "Change number",
  "phoneLinked": "Phone number added.",
  "googleWorking": "Signing in with Google...",
  "googleLinked": "Google account linked.",
  "googleCancelled": "Google sign-in was cancelled.",
  "telegramWorking": "Signing in with Telegram...",
  "telegramCancelled": "Telegram sign-in was cancelled.",
  "signInToLink": "Sign in to your account",
  "telegramWidgetUnavailable": "Telegram web login becomes available once the bot domain is configured. Inside Telegram the Mini App signs you in automatically.",
  "telegramLinked": "Telegram linked.",
  "signInRequired": "Sign in to manage your account security.",
  "loginMethods": "Sign-in methods",
  "methodPassword": "Email and password",
  "methodGoogle": "Google",
  "methodPhone": "Phone (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Linked",
  "notLinked": "Not linked",
  "link": "Link",
  "unlink": "Unlink",
  "unlinked": "Sign-in method removed.",
  "lastMethodHint": "Your only sign-in method cannot be removed.",
  "unavailableProvider": "Not configured",
  "changePasswordTitle": "Change password",
  "setPasswordTitle": "Set a password",
  "currentPassword": "Current password",
  "savePassword": "Save password",
  "passwordSaved": "Password saved. Other sessions were signed out.",
  "changeEmailTitle": "Change email",
  "newEmail": "New email",
  "saveEmail": "Save email",
  "emailSaved": "Email updated. Confirm the new address from your inbox.",
  "reauthTitle": "Confirm it is you",
  "reauthIntro": "For your security, enter your password to continue.",
  "reauthPasswordless": "For your security, sign in again to continue.",
  "reauthCta": "Continue",
  "mfaCode": "Authenticator code",
  "signInAgain": "Sign in again",
  "sessionsTitle": "Sessions",
  "logout": "Log out",
  "logoutAll": "Log out on all devices",
  "phoneNotSet": "No phone number",
  "errors": {
    "invalid_credentials": "Wrong email or password.",
    "too_many_requests": "Too many attempts. Please wait a little and try again.",
    "email_taken": "This email is already registered. Sign in instead.",
    "password_too_short": "Password is too short (minimum 8 characters).",
    "password_too_long": "Password is too long (maximum 128 characters).",
    "password_too_weak": "Password is too weak. Mix letters with digits or symbols.",
    "password_too_common": "This password is too common. Choose another one.",
    "password_contains_email": "Password must not contain your email name.",
    "invalid_or_expired_token": "This link is invalid, expired or has already been used.",
    "invalid_password": "Wrong password.",
    "invalid_email": "Enter a valid email address.",
    "email_not_set": "Your account has no email address.",
    "reauth_required": "Please confirm it is you to continue.",
    "password_not_set": "This account has no password. Sign in again with your linked method.",
    "email_required_for_password": "Add an email address before setting a password.",
    "email_delivery_unavailable": "Email delivery is not configured yet.",
    "sms_disabled": "SMS sign-in is not available yet.",
    "phone_auth_disabled": "Phone registration and SMS sign-in are temporarily disabled.",
    "sms_delivery_failed": "The SMS could not be sent. Try again later.",
    "invalid_phone": "Enter a valid phone number.",
    "resend_cooldown": "Please wait before requesting a new code.",
    "otp_invalid": "Wrong or expired code.",
    "otp_expired": "The code has expired. Request a new one.",
    "otp_attempts_exceeded": "Too many wrong codes. Request a new code.",
    "phone_in_use": "This phone number belongs to another account.",
    "phone_signin_conflict_retry": "Please try again.",
    "google_oauth_disabled": "Google sign-in is not available yet.",
    "telegram_oidc_disabled": "Telegram web sign-in is not available yet.",
    "google_account_exists_link_required": "An account with this Google email already exists. Sign in to it first, then link Google on the Security page.",
    "google_linked_to_other_account": "This Google account is linked to another VBB PLAY account.",
    "google_other_account_linked": "A different Google account is already linked. Unlink it first.",
    "google_signin_conflict_retry": "Please try again.",
    "invalid_state": "The sign-in attempt expired or was started in another browser. Please try again.",
    "state_expired": "The sign-in attempt expired. Please try again.",
    "nonce_mismatch": "Social sign-in could not be verified. Please try again.",
    "invalid_id_token": "Social sign-in could not be verified. Please try again.",
    "token_exchange_failed": "Social sign-in was not confirmed. Please try again.",
    "signing_key_unavailable": "Social sign-in is temporarily unavailable. Please try again.",
    "link_session_mismatch": "Sign in to the same account that started linking.",
    "telegram_already_linked": "This Telegram account is linked to another VBB PLAY account.",
    "telegram_other_account_linked": "A different Telegram account is already linked. Unlink it first.",
    "telegram_payload_required": "Telegram did not return sign-in data.",
    "auth_data_replayed": "This Telegram sign-in was already used. Please sign in again.",
    "auth_data_expired": "The Telegram sign-in expired. Please try again.",
    "invalid_hash": "Telegram sign-in could not be verified.",
    "last_login_method": "Your only sign-in method cannot be removed.",
    "account_suspended": "This account is suspended. Contact support.",
    "admin_email_change_disabled": "Administrator emails can only be changed by an operator.",
    "mfa_required": "Enter the code from your authenticator app."
  }
}
